import {
  ButtonGroup,
  Button,
  Card,
  Row,
  Col,
  Image,
  Accordion,
} from "react-bootstrap";
import Slider from "react-slick";
import { BsChevronLeft, BsChevronRight } from "react-icons/bs";
import { useState, useRef } from "react";
import "./ItineraryContent.css";
import { BsTaxiFrontFill } from "react-icons/bs";
import { ImSpoonKnife } from "react-icons/im";
import PolicyAccordion from "../../Term&Condition";
import EnquiryForm from "../../EnquiryForm";
import { B2BAgents5 } from "../../B2BAgents/B2BAgents5/B2BAgents5";
import { B2BAgents4 } from "../../B2BAgents/B2BAgents4/B2BAgents4";

export const ItineraryContent = ({ data }) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [itemSlides, setItemSlides] = useState({});
  const [activeTab, setActiveTab] = useState("Itinerary");
  const overviewRef = useRef(null);
  const overviewRef2 = useRef(null);
  const itineraryRef = useRef(null);
  const hotelRef = useRef(null);
  const termsRef = useRef(null);
  const confirmRef = useRef(null);
  const refundRef = useRef(null);
  const cancellationRef = useRef(null);
  const [activeAccordion, setActiveAccordion] = useState(null);
  const tabs = [
    // "Overview",
    "Itinerary",
    "Hotels",
    "Inclusion",
    "Exclusion",
    "Terms & Conditions",
    "Confirmation Policy",
    "Refund Policy",
    "Cancellation Policy",
  ];

  const CustomPrevArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="customPrevArrow" onClick={onClick}>
        <BsChevronLeft />
      </div>
    );
  };

  // Custom Next Arrow
  const CustomNextArrow = (props) => {
    const { onClick } = props;
    return (
      <div className="customNextArrow" onClick={onClick}>
        <BsChevronRight />
      </div>
    );
  };

  const parseHtmlToList = (html) => {
    if (!html) return [];

    const temp = document.createElement("div");
    temp.innerHTML = html;

    // ✅ grab all meaningful nodes (p, div, li)
    const elements = temp.querySelectorAll("p, div, li");

    return Array.from(elements)
      .map(el => el.textContent.trim())
      .filter(text => text.length > 0);
  };
  const inclusionList = parseHtmlToList(data.included?.html);
  const exclusionList = parseHtmlToList(data.excluded?.html);
  const termsList = parseHtmlToList(data.termCondition?.html);
  const confirmList = parseHtmlToList(data.confirmation?.html);
  const refundList = parseHtmlToList(data.refund?.html);
  const cancelList = parseHtmlToList(data.cancellation?.html);

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    beforeChange: (oldIndex, newIndex) => setCurrentSlide(newIndex),
    prevArrow: <CustomPrevArrow />,
    nextArrow: <CustomNextArrow />,
  };

  // Handle tab click with scrolling
  const handleTabClick = (tab) => {
    setActiveTab(tab);

    let ref = null;
    let key = null;

    switch (tab) {
      case "Inclusion":
        ref = overviewRef;
        key = "inclusions"; // 👈 open this
        break;

      case "Exclusion":
        ref = overviewRef2;
        key = "exclusions"; // 👈 open this
        break;

      case "Hotels":
        ref = hotelRef;
        key = "hotels";
        break;

      case "Terms & Conditions":
        ref = termsRef;
        key = "terms";
        break;

      case "Confirmation Policy":
        ref = confirmRef;
        key = "confirmation";
        break;

      case "Refund Policy":
        ref = refundRef;
        key = "refund";
        break;

      case "Cancellation Policy":
        ref = cancellationRef;
        key = "cancellation";
        break;

      case "Itinerary":
        ref = itineraryRef;
        break;

      default:
        return;
    }

    if (key) {
      setActiveAccordion(key);

      // 🔥 wait for accordion animation + DOM update
      setTimeout(() => {
        if (ref?.current) {
          scrollWithOffset(ref);
        }
      }, 300); // adjust if needed
    } else {
      if (ref?.current) {
        scrollWithOffset(ref);
      }
    }
  };

  const scrollWithOffset = (ref) => {
    const headerOffset = 140; // adjust based on navbar + tabs height

    const elementPosition =
      ref.current.getBoundingClientRect().top + window.pageYOffset;

    const offsetPosition = elementPosition - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  return (
    <div className="CustomDestinationItinerary2 pb-0">
      <Row>
        <Col md={12} lg={8}>
          <div className="tabContainer mb-4">
            <ButtonGroup className="tabWrapper">
              {tabs.map((tab, index) => {
                const isHotelsTab = tab === "Hotels";
                const showTab = isHotelsTab ? !!data.hotels : true;

                if (!showTab) return null;

                return (
                  <Button
                    key={index}
                    className={`tabButton ${activeTab === tab ? "active-tab" : ""}`}
                    onClick={() => handleTabClick(tab)}
                  >
                    {tab}
                  </Button>
                );
              })}
            </ButtonGroup>
          </div>

          <div ref={itineraryRef}>
            <Card className="ps-0 packageDetailPackageOverview packageDetailItinerary">
              <div className="d-flex align-items-center marginMobile">
                {/* <div className="overviewLabel"></div> */}
                <h4 className="ps-3 packageOverHead">Itinerary</h4>
              </div>

              <div className="sidePaddingPackage itineraryDaysAccordion ">
                <Accordion
                  className="itineraryAccordian"
                  defaultActiveKey={data.itenary[0]?.id}
                >
                  {data.itenary.map((item) => (
                    <Accordion.Item
                      key={item.id}
                      eventKey={item.id}
                      className=""
                    >
                      <Accordion.Header className="ItenaryAccordionHeader border-bottom">
                        <span className="btn rounded-pill daysCountBtn me-lg-3 me-md-2 me-2">
                          {item.days}
                        </span>
                        <p className="mb-0 itenariyDestinationNameList">
                          {item.destination}
                        </p>
                      </Accordion.Header>

                      <Accordion.Body>
                        <p className="text mb-3">{item.description}</p>

                        {item.images && item.images.length > 0 && (
                          <div className="position-relative">
                            <Slider
                              {...{
                                ...settings,
                                beforeChange: (oldIndex, newIndex) => {
                                  setItemSlides((prev) => ({
                                    ...prev,
                                    [item.id]: newIndex,
                                  }));
                                },
                              }}
                            >
                              {item?.images?.map((img, index) => (
                                <div key={index} className="position-relative">
                                  <Image
                                    src={img}
                                    alt={`Slide ${index + 1}`}
                                    className="img-fluid rounded w-100 object-fit-cover"
                                    style={{ height: "300px" }}
                                  />
                                  <div className="itinerary-dots">
                                    {item.images.map((_, dotIndex) => (
                                      <span
                                        key={dotIndex}
                                        className={`itinerary-dot ${(itemSlides[item.id] || 0) ===
                                          dotIndex
                                          ? "itinerary-dot-active"
                                          : ""
                                          }`}
                                      ></span>
                                    ))}
                                  </div>
                                </div>
                              ))}
                            </Slider>
                          </div>
                        )}

                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </Card>
          </div>

          <div className="mt-3">
            <Accordion
              activeKey={activeAccordion}
              onSelect={(eventKey) => setActiveAccordion(eventKey)}
            >
              {/* Inclusions */}
              <Accordion.Item
                eventKey="inclusions" ref={overviewRef}
                className="packageDetailPackageOverview  mt-3"
              >
                <Accordion.Header className="InclusionsItenaryAccordionHeader">
                  <h6 className="packageOverHead mb-0">
                    {data.included.title}
                  </h6>
                </Accordion.Header>
                <Accordion.Body>
                  {inclusionList.length > 0 ? (
                    <ul className="packageOverviewUl">
                      {inclusionList.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  ) : (
                    <p>No inclusions available</p>
                  )}
                </Accordion.Body>
              </Accordion.Item>

              {/* Exclusions */}
              <Accordion.Item
                eventKey="exclusions" ref={overviewRef2}
                className=" packageDetailPackageOverview mt-3"
              >
                <Accordion.Header className="InclusionsItenaryAccordionHeader">
                  <h6 className="packageOverHead mb-0">
                    {data.excluded.title}
                  </h6>
                </Accordion.Header>
                <Accordion.Body>
                  {exclusionList.length > 0 ? (
                    <ul className="packageOverviewUl">
                      {exclusionList.map((item, index) => (
                        <li key={index}>{item}</li>
                      ))}
                    </ul>
                  ) : (
                    <p>No exclusions available</p>
                  )}
                </Accordion.Body>
              </Accordion.Item>

              {/* Hotels */}
              {data.hotels && (
                <Accordion.Item
                  ref={hotelRef}
                  eventKey="hotels"
                  className="packageDetailPackageOverview  mt-3"
                >
                  <Accordion.Header className="InclusionsItenaryAccordionHeader">
                    <h6 className="packageOverHead mb-0">
                      Hotel Options
                    </h6>
                  </Accordion.Header>
                  <Accordion.Body>
                    {data.hotels.length > 0 ? (
                      <div className="hotel-section">
                        {data.hotels.map((hotel, index) => (
                          <div key={index} className="hotel-block">
                            <p>
                              <strong>Location:</strong> {hotel.destination}
                            </p>

                            {hotel.standard && (
                              <p>
                                <strong>3 Star Hotel:</strong> {hotel.standard}
                              </p>
                            )}

                            {hotel.deluxe && (
                              <p>
                                <strong>4 Star Hotel:</strong> {hotel.deluxe}
                              </p>
                            )}

                            {hotel.premium && (
                              <p>
                                <strong>5 Star Hotel:</strong> {hotel.premium}
                              </p>
                            )}

                            {index !== data.hotels.length - 1 && (
                              <hr className="hotel-divider" />
                            )}
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p>No hotel data available</p>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              )}

              {/* Terms & Conditions */}
              {termsList.length > 0 && (
                <Accordion.Item eventKey="terms" ref={termsRef}
                  className="packageDetailPackageOverview  mt-3">
                  <Accordion.Header className="InclusionsItenaryAccordionHeader">
                    <h6 className="packageOverHead mb-0">{data.termCondition.title}</h6>
                  </Accordion.Header>

                  <Accordion.Body>
                    <ul className="packageOverviewUl">
                      {termsList.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              )}

              {/* Confirmation Policy */}
              {confirmList.length > 0 && (
                <Accordion.Item eventKey="confirmation" ref={confirmRef}
                  className="packageDetailPackageOverview  mt-3">
                  <Accordion.Header className="InclusionsItenaryAccordionHeader">
                    <h6 className="packageOverHead mb-0">{data.confirmation.title}</h6>
                  </Accordion.Header>

                  <Accordion.Body>
                    <ul className="packageOverviewUl">
                      {confirmList.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              )}

              {/* Refund Policy */}
              {refundList.length > 0 && (
                <Accordion.Item eventKey="refund" ref={refundRef}
                  className="packageDetailPackageOverview  mt-3">
                  <Accordion.Header className="InclusionsItenaryAccordionHeader">
                    <h6 className="packageOverHead mb-0">{data.refund.title}</h6>
                  </Accordion.Header>

                  <Accordion.Body>
                    <ul className="packageOverviewUl">
                      {refundList.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              )}

              {/* Cancellation Policy */}
              {cancelList.length > 0 && (
                <Accordion.Item eventKey="cancellation" ref={cancellationRef}
                  className="packageDetailPackageOverview  mt-3">
                  <Accordion.Header className="InclusionsItenaryAccordionHeader">
                    <h6 className="packageOverHead mb-0">{data.cancellation.title}</h6>
                  </Accordion.Header>

                  <Accordion.Body>
                    <ul className="packageOverviewUl">
                      {cancelList.map((item, i) => (
                        <li key={i}>{item}</li>
                      ))}
                    </ul>
                  </Accordion.Body>
                </Accordion.Item>
              )}
            </Accordion>
          </div>
        </Col>
        <Col md={12} lg={4}>
          <EnquiryForm />
        </Col>
      </Row>
    </div>
  );
};
